/**
 * Utilidades para la auditoría IA Cali
 */

/**
 * Prepara y limpia el contexto (configuración y regímenes) para ahorrar tokens.
 * Elimina timestamps y datos irrelevantes.
 */
export const prepararContexto = (config, regimenes) => {
    const configLimpio = { ...config };
    const regimenesLimpio = { ...regimenes };

    // Eliminar metadatos innecesarios de config
    delete configLimpio.created_at;
    delete configLimpio.updated_at;
    delete configLimpio.ruc_empresa; // Ya sabemos la empresa implícitamente

    // Eliminar metadatos innecesarios de regimenes
    if (regimenesLimpio.parametros) {
        // Mantenemos solo parametros, no timestamps del documento padre
        // Pero si regimenesLimpio YA es el objeto interno, ok.
        // Asumimos que recibimos el objeto 'parametros' directamente o el doc completo.
        // Ajustamos según lo que envíe el componente.
    }

    // Si regimenes viene con timestamps fuera de 'parametros', limpiamos
    delete regimenesLimpio.created_at;
    delete regimenesLimpio.updated_at;
    delete regimenesLimpio.ruc_empresa;

    return {
        configuracion_global: configLimpio,
        regimenes_laborales: regimenesLimpio
    };
};

/**
 * Limpia los detalles de la planilla para enviar solo lo necesario a la IA.
 * Reduce consumo de tokens eliminando campos redundantes o calculados intermedios
 * que no son vitales para la auditoría final.
 */
const limpiarDetalleEmpleado = (detalle) => {
    const d = { ...detalle };

    // Mantenemos IDs y Nombres para identificar
    // Eliminamos timestamps
    delete d.created_at;
    delete d.updated_at;
    delete d.planilla_id;
    delete d.ruc_empresa;
    // Mantenemos empleado_id para consultas de historial

    // Opcional: Eliminar desglose muy detallado si la IA solo valida totales
    // Pero para una auditoría profunda, mejor dejar los desgloses de ingresos/descuentos.

    return d;
};

/**
 * Divide la lista de detalles en lotes (chunks).
 */
export const crearLotes = (detalles, tamanoLote = 20) => {
    // Reducimos tamaño por defecto a 20 para asegurar que quepa en contexto 
    // si el JSON de cada empleado es grande.
    const detallesLimpios = detalles.map(limpiarDetalleEmpleado);
    const lotes = [];

    for (let i = 0; i < detallesLimpios.length; i += tamanoLote) {
        lotes.push(detallesLimpios.slice(i, i + tamanoLote));
    }

    return lotes;
};

/**
 * Consolida los resultados de múltiples lotes en un solo reporte.
 */
export const consolidarResultados = (listaDeResultados) => {
    const reporteFinal = {
        aprobado: true,
        observaciones: [],
        metricas: {
            lotes_procesados: listaDeResultados.length,
            errores_criticos: 0,
            advertencias: 0
        }
    };

    listaDeResultados.forEach(res => {
        if (!res) return;

        // Si algún lote falla (aprobado = false), el global falla si es crítico
        // Pero la IA decide 'aprobado' basado en su criterio.
        // Nosotros recalculamos basado en observaciones encontradas.

        if (res.observaciones && Array.isArray(res.observaciones)) {
            reporteFinal.observaciones.push(...res.observaciones);

            res.observaciones.forEach(obs => {
                if (obs.tipo === 'CRITICO') {
                    reporteFinal.aprobado = false;
                    reporteFinal.metricas.errores_criticos++;
                } else if (obs.tipo === 'ADVERTENCIA') {
                    reporteFinal.metricas.advertencias++;
                }
            });
        }
    });

    return reporteFinal;
};
